import { CarrierValidationStatus, type CarrierValidationStatusType } from '@cart-services/core/carrier-validation-status'
import { type ValueOf } from '@dni-types/utilities/value-of'
import { type CarrierValidateType } from '@hooks-api/types/apiRequest'
import { type CarrierValidationResultStatus } from '@hooks-api/types/apiResponse'
import { RemindCircle } from '@pets-ui/icons'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { type ReactNode } from 'react'

export { CarrierValidationStatus }
export type { CarrierValidationStatusType }

export const PHONE_CARRIER_SUFFIX_LENGTH = 7

export const PHONE_CARRIER_VALIDATE_TYPE: CarrierValidateType = 'phone_carrier'

export const apiStatusToCarrierStatus: Record<CarrierValidationResultStatus, CarrierValidationStatusType> = {
  valid: CarrierValidationStatus.VALID,
  not_found: CarrierValidationStatus.NOT_FOUND,
  invalid_format: CarrierValidationStatus.FORMAT_ERROR,
}

export const deriveLocalCarrierStatus = (sanitizedSuffix: string): CarrierValidationStatusType => {
  if (sanitizedSuffix.length === 0) return CarrierValidationStatus.EMPTY
  if (sanitizedSuffix.length > PHONE_CARRIER_SUFFIX_LENGTH) return CarrierValidationStatus.FORMAT_ERROR
  if (sanitizedSuffix.length === PHONE_CARRIER_SUFFIX_LENGTH) return CarrierValidationStatus.VALIDATING
  return CarrierValidationStatus.INCOMPLETE
}

export const CarrierStatusSeverity = {
  NONE: 'none',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
} as const

export type CarrierStatusSeverityType = ValueOf<typeof CarrierStatusSeverity>

export interface CarrierStatusDisplay {
  message: string
  severity: CarrierStatusSeverityType
  icon?: ReactNode
  color?: string
}

// 手機條碼為台灣專用發票功能，文案僅 zh-TW、不走 i18n（避免被改回 t() 造成非 zh-TW 語系顯示 key）
export const carrierStatusDisplayMap: Record<CarrierValidationStatusType, CarrierStatusDisplay> = {
  [CarrierValidationStatus.EMPTY]: { message: '', severity: CarrierStatusSeverity.NONE },
  [CarrierValidationStatus.INCOMPLETE]: { message: '', severity: CarrierStatusSeverity.NONE },
  [CarrierValidationStatus.FORMAT_ERROR]: { message: '請輸入完整後 7 碼：限數字 0-9、大寫英文 A-Z 及 + - .', severity: CarrierStatusSeverity.ERROR },
  [CarrierValidationStatus.VALIDATING]: { message: '驗證中…', severity: CarrierStatusSeverity.LOADING },
  [CarrierValidationStatus.VALID]: { message: '有效載具', severity: CarrierStatusSeverity.SUCCESS, icon: <RemindCircle color={colors.green600} fontSize={16} />, color: colors.green600 },
  [CarrierValidationStatus.NOT_FOUND]: { message: '查無此手機條碼，請確認後重新輸入，或改用其他索取方式', severity: CarrierStatusSeverity.ERROR },
  [CarrierValidationStatus.SYSTEM_ERROR]: { message: '有效載具', severity: CarrierStatusSeverity.SUCCESS, icon: <RemindCircle color={colors.green600} fontSize={16} />, color: colors.green600 },
}

// 送出 gate 專用文案：EMPTY / INCOMPLETE 在欄位下方無即時訊息，送出時才於此 focus 報錯
export const carrierSubmitMessageMap: Partial<Record<CarrierValidationStatusType, string>> = {
  [CarrierValidationStatus.EMPTY]: '必填欄位',
  [CarrierValidationStatus.INCOMPLETE]: '請輸入完整手機條碼後 7 碼',
}
